import { useMemo } from 'react'

import { FilterOption } from '../types'

interface UseEligibleForHireFilterProps {
  selectedEligibleForHire: string[]
  onEligibleForHireChange: (values: string[]) => void
}

export const useEligibleForHireFilter = ({
  selectedEligibleForHire,
  onEligibleForHireChange,
}: UseEligibleForHireFilterProps) => {
  const baseOptions = useMemo<FilterOption[]>(() => {
    return [
      { value: 'true', label: 'Yes' },
      { value: 'false', label: 'No' },
    ]
  }, [])

  // Update options to reflect selected state
  const options = useMemo<FilterOption[]>(() => {
    return baseOptions.map((option) => ({
      ...option,
      selected: selectedEligibleForHire.includes(option.value),
    }))
  }, [baseOptions, selectedEligibleForHire])

  return {
    options,
    selected: selectedEligibleForHire,
    onChange: onEligibleForHireChange,
    isLoaded: true,
  }
}
